<template>
  <div>
    <maintenance v-if="onMaintenance" />
    <browser v-else-if="isInApp" />
    <non-published v-else-if="!isPublishable" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Browser from '~/components/Browser'
import Maintenance from '~/components/Maintenance'
import NonPublished from '~/components/NonPublished'

export default {
  layout: 'plain',
  components: {
    'browser': Browser,
    'maintenance': Maintenance,
    'non-published': NonPublished
  },
  computed: {
    ...mapGetters('config', [
      'isInApp', 'onMaintenance', 'isPublishable'
    ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/info.vue